/* ============================================================
   ICExtract — Hero slideshow
   Vanilla JS, accessible rotating banner.
   - Per-section init guard via data-attribute
   - Autoplay with pause on hover / focus-within
   - Respects prefers-reduced-motion (no autoplay)
   - Dot + arrow buttons update aria-live region
   ============================================================ */
(function () {
  'use strict';

  if (window.__icHeroSlideshowInit) {
    // Still allow late-added sections (Theme Editor) to init below.
  } else {
    window.__icHeroSlideshowInit = true;
  }

  var prefersReducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function initSlideshow(root) {
    if (!root || root.dataset.icHeroSlideshowReady === 'true') return;
    root.dataset.icHeroSlideshowReady = 'true';

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('.ic-hero-slideshow__slide')
    );
    if (slides.length <= 1) return;

    var dots = Array.prototype.slice.call(
      root.querySelectorAll('.ic-hero-slideshow__dot')
    );
    var prevBtn = root.querySelector('.ic-hero-slideshow__arrow--prev');
    var nextBtn = root.querySelector('.ic-hero-slideshow__arrow--next');
    var liveRegion = root.querySelector('.ic-hero-slideshow__live');

    var autoplay = root.dataset.autoplay === 'true' && !prefersReducedMotion;
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var total = slides.length;
    var current = 0;
    var timer = null;

    function announce(index) {
      if (liveRegion) {
        liveRegion.textContent = 'Slide ' + (index + 1) + ' of ' + total;
      }
    }

    function goTo(index) {
      index = (index + total) % total;
      slides.forEach(function (slide, i) {
        var isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      current = index;
      announce(index);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay || timer) return;
      timer = window.setInterval(next, interval);
    }
    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        restartAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        restartAutoplay();
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        restartAutoplay();
      });
    });

    // Pause on hover
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    // Pause on keyboard focus within the carousel
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) startAutoplay();
    });

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    goTo(0);
    startAutoplay();
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll('.ic-hero-slideshow');
    Array.prototype.forEach.call(roots, initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
